module.exports = __webpack_public_path__ + "assets/img/2.f579b212.jpg";